export default {
  title: 'We are logging you in...',
  subtitle: 'you will be automatically redirected',
  error: {
    generic: 'There was a problem logging you in. Please try again.',
    invalidCode: 'Your sign-in link has expired. Please try again.',
    onlyNew: 'This program is only available to new users.',
  },
}
